import CustomSourceFlowText from "@/components/Shared/CustomSourceflowText";
import Testimonials from "@/components/Shared/Testimonials";
import { TESTIMONIALS_CUSTOM_STYLES } from "@/constants/candidates";
import useLocale from "@/hooks/useLocale";

export default function ServicePageSwiper() {
  const locale = useLocale();

  return (
    <div className="pt-[108px] flex flex-col gap-10 md:gap-0">
      <h2 className="text-3xl sm:text-[40px] xl:text-[50px]/[60px] max-w-[628px] text-center self-center">
        <CustomSourceFlowText
          title="Our partners experience with Retained Search"
          path="dynamic1.swiper.header1"
          locale={locale}
        />
        <span className="text-green">.</span>
      </h2>
      <div className="-mt-20">
        <Testimonials customStyles={TESTIMONIALS_CUSTOM_STYLES} />
      </div>
    </div>
  );
}
